






















import Vue from 'vue'

import { panels } from '@/panels'

export default Vue.extend({
  name: 'WindowToolbox',
  data() {
    return {
      panels,
    }
  },
  methods: {
    // eslint-disable-next-line
    handleDrag($event: any, component: any) {
      $event.dataTransfer.setData('component-def', JSON.stringify(component))
    },
  },
  created() {
    //
  },
})
